<template>
  <div> <v-row>
      <v-col cols="12">
        <v-card flat rounded="lg">
          <v-card-subtitle class="font-weight-bold black--text subtitle-1">
            Meus saldos
          </v-card-subtitle>

          <v-card-text>
            <v-row v-if="carregando">
              <v-col
                xl="3"
                lg="3"
                md="3"
                sm="12"
                cols="12"
                v-for="(num, i) in 4"
                :key="i"
              >
                <v-skeleton-loader
                  class="mx-auto rounded-lg"
                  max-height="150"
                  min-width="200"
                  type="image"
                ></v-skeleton-loader>
              </v-col>
            </v-row>

            <v-row v-else-if="saldos.length == 0">
              <v-col cols="12">
                <v-alert type="info" text>Não há saldos disponíveis para serem exibidos</v-alert>
              </v-col>
            </v-row>

            <v-row v-else>
              <v-col
                xl="3"
                lg="3"
                md="4"
                sm="6"
                cols="12"
                v-for="(saldo, index) in saldosParaExibir"
                :key="index"
              >
                <v-card
                  v-if="saldo.id === 'vale_alimentacao'"
                  flat
                  class="h-100 rounded-xl pa-4 text-center transition-swing"
                  style="background-color: #e3f2fd"
                  @click="onPressedSaldo(saldo)"
                >
                  <div
                    class="text-h6 font-weight-black mb-0"
                    style="color: #1976d2; line-height: 1.2"
                  >
                    {{ saldo.descricao || "Vale Alimentação" }}
                  </div>
                  <div class="caption font-weight-bold mb-2" style="color: #64b5f6">
                    + Créditos
                  </div>
                  <div
                    class="caption font-weight-black grey--text text--darken-1 text-uppercase"
                    style="font-size: 0.65rem !important"
                  >
                    Saldo Disponível
                  </div>
                  <div class="text-h5 font-weight-black mb-2" style="color: #0d47a1">
                    {{ maskMoeda(saldo.saldo) }}
                  </div>
                </v-card>

                <v-card
                  v-else-if="saldo.id === 'conta_consumo'"
                  flat
                  class="h-100 rounded-xl pa-4 text-center d-flex flex-column justify-center transition-swing"
                  style="background-color: #fff3e0"
                  @click="onPressedSaldo(saldo)"
                >
                  <div
                    class="text-h6 font-weight-black mb-2"
                    style="color: #e65100; line-height: 1.2"
                  >
                    {{ saldo.descricao }}
                  </div>
                  <div
                    class="caption font-weight-black text-uppercase"
                    style="color: #fb8c00; font-size: 0.65rem !important"
                  >
                    Limite Disponível
                  </div>
                  <div class="text-h5 font-weight-black mb-2" style="color: #bf360c">
                    {{ maskMoeda(saldo.saldo) }}
                  </div>
                  <div
                    class="caption font-weight-bold text-uppercase"
                    style="color: #fb8c00; font-size: 0.6rem !important"
                  >
                    Limite Usado
                  </div>
                  <div class="subtitle-2 font-weight-bold" style="color: #e65100">
                    {{ maskMoeda(saldo.usado) }}
                  </div>
                  <div
                    v-if="saldo.msg_rodape"
                    class="caption mt-1 grey--text text--darken-1 italic"
                  >
                    {{ saldo.msg_rodape }}
                  </div>
                </v-card>

                <template v-else-if="saldo.id === 'conta_cliente'">
                  <v-card
                    v-if="!saldo.pode_usar_lim"
                    flat
                    class="h-100 rounded-xl pa-4 text-center d-flex flex-column justify-center transition-swing"
                    style="background-color: #ffebee"
                    @click="onPressedSaldo(saldo)"
                  >
                    <div
                      class="text-h6 font-weight-black mb-2"
                      style="color: #c62828; line-height: 1.2"
                    >
                      {{ saldo.descricao }}
                    </div>
                    <div
                      class="caption font-weight-black text-uppercase"
                      style="color: #e53935; font-size: 0.65rem !important"
                    >
                      Indisponível
                    </div>
                    <div
                      class="text-h5 font-weight-black text-decoration-line-through grey--text text--lighten-1 mb-2"
                    >
                      {{ maskMoeda(saldo.saldo) }}
                    </div>
                    <div
                      class="body-2 font-weight-medium px-2 mb-1"
                      style="color: #c62828; line-height: 1.2"
                    >
                      Só estará disponível assim que usar todo o limite da
                      <span class="font-weight-black">Conta Consumo.</span>
                    </div>
                    <div
                      v-if="saldo.msg_rodape"
                      class="caption grey--text text--darken-1 italic"
                    >
                      {{ saldo.msg_rodape }}
                    </div>
                  </v-card>
                  <v-card
                    v-else
                    flat
                    class="h-100 rounded-xl pa-4 text-center d-flex flex-column justify-center transition-swing"
                    style="background-color: #e8f5e9"
                    @click="onPressedSaldo(saldo)"
                  >
                    <div
                      class="text-h6 font-weight-black mb-2"
                      style="color: #2e7d32; line-height: 1.2"
                    >
                      {{ saldo.descricao }}
                    </div>
                    <div
                      class="caption font-weight-black text-uppercase"
                      style="color: #4caf50; font-size: 0.65rem !important"
                    >
                      Limite Disponível
                    </div>
                    <div class="text-h5 font-weight-black mb-2" style="color: #1b5e20">
                      {{ maskMoeda(saldo.saldo) }}
                    </div>
                    <div
                      class="caption font-weight-bold text-uppercase"
                      style="color: #4caf50; font-size: 0.6rem !important"
                    >
                      Limite Usado
                    </div>
                    <div class="subtitle-2 font-weight-bold mb-1" style="color: #2e7d32">
                      {{ maskMoeda(saldo.usado) }}
                    </div>
                    <div
                      v-if="saldo.msg_rodape"
                      class="caption grey--text text--darken-1 italic"
                    >
                      {{ saldo.msg_rodape }}
                    </div>
                  </v-card>
                </template>

                <v-card
                  v-else-if="saldo.id === 'cartao_premio'"
                  flat
                  class="h-100 rounded-xl pa-4 text-center d-flex flex-column justify-center transition-swing"
                  style="background-color: #e0f2f1"
                  @click="onPressedSaldo(saldo)"
                >
                  <div
                    class="text-h6 font-weight-black mb-2"
                    style="color: #00695c; line-height: 1.2"
                  >
                    {{ saldo.descricao || "Cartão Prêmio" }}
                  </div>
                  <div
                    class="caption font-weight-black text-uppercase"
                    style="color: #26a69a; font-size: 0.65rem !important"
                  >
                    Saldo Disponível
                  </div>
                  <div class="text-h5 font-weight-black" style="color: #004d40">
                    {{ maskMoeda(saldo.saldo) }}
                  </div>
                  <div
                    v-if="saldo.msg_rodape"
                    class="caption mt-2 grey--text text--darken-1 italic"
                  >
                    {{ saldo.msg_rodape }}
                  </div>
                </v-card>
              </v-col>
            </v-row>

            <creditos-recebidos
              v-if="getCreditosRecebidos()"
              :creditos="getCreditosRecebidos().detalhe"
            />
            <gastos-conta-cliente v-if="getContasConsumo()" />
          </v-card-text>
        </v-card>
      </v-col>
    </v-row>

    <extrato-vale-dialog 
      v-model="dialogExtratoVale" 
      :cta="ctaExtratoVale" 
      :nome-vale="nomeExtratoVale" 
    />
  </div>
</template>

<script>
import axios from "axios";
import { formatMoeda } from "@/global";
import CreditosRecebidos from "./CreditosRecebidos.vue";
import { mapMutations, mapState } from "vuex";
import GastosContaCliente from "./GastosContaCliente.vue";
// 1. IMPORTANDO O COMPONENTE (Verifique se o caminho './ExtratoValeDialog.vue' está correto para o seu projeto)
import ExtratoValeDialog from "./ExtratoValeDialog.vue"; 

export default {
  // 2. REGISTRANDO O COMPONENTE
  components: { CreditosRecebidos, GastosContaCliente, ExtratoValeDialog }, 
  computed: {
    ...mapState("usuario", ["gerencial"]),
    saldosParaExibir() {
      const order = [
        "vale_alimentacao",
        "conta_consumo",
        "conta_cliente",
        "cartao_premio",
      ];
      return this.saldos
        .slice()
        .sort((a, b) => order.indexOf(a.id) - order.indexOf(b.id));
    },
  },
  data: () => ({
    carregando: false,
    saldos: [],
    // 3. VARIÁVEIS DE CONTROLE DO NOVO DIALOG
    dialogExtratoVale: false,
    ctaExtratoVale: '',
    nomeExtratoVale: '',
  }),
  methods: {
    ...mapMutations("home", [
      "setDialogCredRecebidos",
      "setDialogGastosCliente",
    ]),
    maskMoeda(value) {
      return formatMoeda(value, 2);
    },
    getCreditosRecebidos() {
      return this.saldos.find((saldo) => saldo.cta == "91");
    },
    getContasConsumo() {
      return this.saldos.find((saldo) => saldo.cta == "11");
    },
    onPressedSaldo(saldo) {
      if (this.gerencial) return;

      // 4. NOVA LÓGICA DO VALE ALIMENTAÇÃO AQUI
     /* if (saldo.id === 'vale_alimentacao') {
        this.ctaExtratoVale = saldo.cta || '87'; // Passa o CTA da API (ou 87 como segurança)
        this.nomeExtratoVale = saldo.descricao || 'Vale Alimentação';
        this.dialogExtratoVale = true; // Abre o modal
      } */
      // MANTENDO A LÓGICA ANTIGA PARA OS OUTROS CARDS
      else if (saldo.cta == "91") {
        this.setDialogCredRecebidos(true);
      } else if (saldo.cta == "37") {
        this.setDialogGastosCliente(true);
      } else if (saldo.cta == "11") {
        this.$router.push("limites-consumo");
      }
    },
    async getSaldosContas() {
      this.carregando = true;
      try {
        const res = await axios.get(`/colaborador/cards-saldos`);
        if (res.data.success) {
          this.saldos = res.data.data;
        }
      } catch (e) {
        console.error(e);
      } finally {
        this.carregando = false;
      }
    },
  },
  async mounted() {
    await this.getSaldosContas();
  },
};
</script>